<template>
    <QualificationField
        :title="$t('profile.vetting.qualification.other.professional.background.title')"
        data-testid="admin-section-tabs-qualification-professional-background"
    >
        <VJoyCheckboxGroup
            v-if="profileQualificationStore.inEditMode"
            :options="allOtherProfessionalBackgrounds"
            :value="profileQualificationStore.qualificationUpdateForm.selectedOtherProfessionalBackgrounds"
            data-testid="vetting-other-professional-background-edition"
            @update:value="(value) => (profileQualificationStore.qualificationUpdateForm.selectedOtherProfessionalBackgrounds = value)"
        />

        <div v-else class="professional-background-tags" data-testid="vetting-other-professional-background-list">
            <VJoyTag
                v-for="selected in reorderedSelectedOtherProfessionalBackgrounds"
                :key="selected"
                :label="selected"
                variant="secondary"
                :data-testid="`vetting-other-professional-background-list-element__${selected}`"
            />
        </div>
    </QualificationField>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {VJoyCheckboxGroup, VJoyTag} from '@maltjoy/core-vue';
    import type {OtherProfessionalBackground} from '@api';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const otherProfessionalBackgroundEnum: Record<OtherProfessionalBackground, string> = {
        BANK: 'Banks',
        INDUSTRY: 'Industry',
        STARTUP: 'Startup/Internet',
    };

    const profileQualificationStore = useProfileQualificationStore();

    const reorderedSelectedOtherProfessionalBackgrounds = computed(() => {
        return allOtherProfessionalBackgrounds.value
            .filter((it) => profileQualificationStore.qualificationUpdateForm.selectedOtherProfessionalBackgrounds.includes(it.value))
            .map((it) => it.label);
    });

    const allOtherProfessionalBackgrounds = computed(() => {
        return (Object.keys(otherProfessionalBackgroundEnum) as OtherProfessionalBackground[]).map((key) => {
            return {
                value: key,
                id: key,
                label: otherProfessionalBackgroundEnum[key],
            };
        });
    });
</script>

<style lang="scss" scoped>
    .professional-background-tags {
        display: flex;
        gap: var(--joy-core-spacing-4);
    }
</style>
